// Constantes legais e de conformidade
export const LEGAL_CONSTANTS = {
  // Versão atual dos termos de uso e política de privacidade
  // Atualizado em 7 de maio de 2026 com melhorias jurídicas para SaaS
  TERMS_VERSION: '2026-05-07-v3',
  PRIVACY_VERSION: '2026-05-07-v3',

  // URLs das páginas legais
  TERMS_URL: '/termos',
  PRIVACY_URL: '/privacidade',

  // Configurações de aceite
  ACCEPTANCE_REQUIRED: true,

  // Chave base para override local de aceite (casos de erro de constraint)
  TERMS_ACCEPTANCE_OVERRIDE_PREFIX: 'terms_acceptance_override',
} as const;

// Tipos para aceite de termos
export interface TermsAcceptanceData {
  accepted_terms: boolean;
  accepted_privacy: boolean;
  accepted_terms_at: string | null;
  accepted_privacy_at: string | null;
  terms_version: string | null;
  privacy_version: string | null;
}